<template>
  <div>
    <Form ref="searchForm" :label-width="60" :model="form">
      <FormItem label="搜索：" style="width:100%;margin:10px 0 ;">
        <Select v-model="form.modal" style="width:180px" class="fl">
          <Option
            v-for="item in modalList"
            :value="item.value"
            :key="item.id"
            >{{ item.label }}</Option
          >
        </Select>
        <Input
          type="text"
          style="width:200px;"
          v-model="form.val"
          placeholder=""
        />
        <Button @click="searchFn">搜索</Button>
      </FormItem>
    </Form>

    <div class="testCon pr">
      <Table
        ref="processCom"
        stripe
        border
        height="460"
        :columns="columns"
        row-key="ppid"
        :data="processLog"
      >
        <template slot-scope="{ row, index }" slot="name">
          {{ $MethodFn.getName(row.path) }}
        </template>
      </Table>
      <!-- <div class="scrollbar" ref="scrollbar">
        <div ref="inScrollbar" :style="{ height: scrollHeight }"></div>
      </div> -->
    </div>
    <div class="testCon pr">
      <Table
        stripe
        v-if="type == 0"
        border
        height="294"
        :columns="columns2"
        :data="newModalLog"
      >
        <template slot-scope="{ row, index }" slot="name">
          <strong style="">{{ $MethodFn.getName(row.path) }}</strong>
        </template>
      </Table>
      <Table
        stripe
        v-else
        border
        height="294"
        :columns="columns3"
        :data="newTcpLog"
      >
        <template slot-scope="{ row }" slot="subid">
          <span v-if="row.subid == 3">UDP</span>
          <span v-if="row.subid == 4">TCP</span>
          <span v-if="row.subid == 5">ICMP</span>
          <span v-if="row.subid == 6">DNS</span>
          <span v-if="row.subid == 7">HTTP</span>
          <span v-if="row.subid == 8">IGMP</span>
          <span v-if="row.subid == 9">RDP</span>
        </template>
        <template slot-scope="{ row }" slot="type">
          <p class="tac" v-if="row.dir">接收</p>
          <p class="tac" v-else>发出</p>
        </template>
      </Table>
      <div class="scrollbar2" ref="scrollbar2">
        <div ref="inScrollbar2" :style="{ height: scrollHeight2 }"></div>
      </div>
    </div>
    <ButtonGroup type="button" v-model="type">
      <Button
        @click="changeType"
        :type="type == 0 ? 'primary' : 'default'"
        label="1"
        >模块信息</Button
      >
      <Button
        @click="changeType"
        :type="type == 1 ? 'primary' : 'default'"
        label="2"
        >TCP/IP</Button
      >
    </ButtonGroup>
  </div>
</template>
<style>
.ivu-table-cell-tree {
  float: left;
  margin-left: 10px;
}
.ivu-table-cell-slot {
  float: left;
  margin-left: 10px;
}
</style>
<script>
import VirtualList from 'vue-virtual-scroll-list'
export default {
  components: { VirtualList },
  props: ['processLog', 'modalLog', 'tcpLog', 'fileLog'],
  data() {
    return {
      type: 0,
      form: {
        val: '',
        modal: '',
      },
      scrollHeight: 0,
      newProcessLog: [],
      newModalLog: [],
      newTcpLog: [],
      scrollbarTop: 0,
      scrollbarTop2: 0,
      scrollHeight2: 0,
      modalList: [
        {
          id: 1,
          value: '搜索进程',
          label: '搜索进程',
        },
        {
          id: 2,
          value: '搜索模块（当前进程）',
          label: '搜索模块（当前进程）',
        },
        {
          id: 3,
          value: '搜索模块（所有进程）',
          label: '搜索模块（所有进程）',
        },
      ],
      columns: [
        {
          title: '进程名',
          slot: 'name',
          align: 'center',
          tooltip: true,
          width: 200,
          resizable: true,
          tree: true,
          expand: true,
        },
        {
          title: '父进程ID',
          key: 'ppid',
          sortable: true,
          align: 'center',
          tooltip: true,
          width: 120,
          resizable: true,
        },
        {
          title: '进程ID',
          key: 'pid',
          sortable: true,
          align: 'center',
          tooltip: true,
          width: 120,
          resizable: true,
        },
        {
          title: '创建时间',
          key: 'time',
          sortable: true,
          align: 'center',
          tooltip: true,
          width: 200,
          resizable: true,
        },
        {
          title: '销毁时间',
          key: 'destoryTime',
          sortable: true,
          align: 'center',
          tooltip: true,
          width: 200,
          resizable: true,
        },
        {
          title: '路径',
          key: 'path',
          tooltip: true,
          resizable: true,
        },
        {
          title: '命令行',
          key: 'cmd',
          tooltip: true,
          resizable: true,
        },
        {
          title: 'MD5',
          key: 'MD5',
          align: 'center',
          tooltip: true,
          width: 160,
          resizable: true,
        },
        {
          title: 'Hash',
          key: 'name',
          align: 'center',
          tooltip: true,
          width: 160,
          resizable: true,
        },
      ],
      columns2: [
        {
          title: '模块名称',
          slot: 'name',
          sortable: true,
          align: 'center',
          width: 200,
        },
        {
          title: '镜像类型',
          key: 'x64',
          sortable: true,
          align: 'center',
          width: 140,
        },
        {
          title: '时间',
          key: 'time',
          sortable: true,
          align: 'center',
          width: 200,
        },
        {
          title: '模块路径',
          key: 'path',
          sortable: true,
          align: 'center',
        },
        {
          title: 'HASH',
          key: 'hash',
          sortable: true,
          align: 'center',
        },
        {
          title: 'MD5',
          key: 'name',
          sortable: true,
          align: 'center',
        },
        {
          title: '文件厂商',
          key: 'name',
          sortable: true,
          align: 'center',
        },
        {
          title: '数字签名',
          key: 'name',
          sortable: true,
          align: 'center',
        },
      ],
      columns3: [
        {
          title: '协议',
          slot: 'subid',
          align: 'center',
          width: 120,
        },
        {
          title: '类型',
          slot: 'type',
          width: 120,
          align: 'center',
        },
        {
          title: '时间',
          key: 'time',
          sortable: true,
          align: 'center',
          tooltip: true,
          width: 200,
        },
        {
          title: '本地地址》远程地址',
          key: 'addr',
          sortable: true,
          align: 'center',
          tooltip: true,
        },
        {
          title: '缓存',
          key: 'buf',
          sortable: true,
          align: 'center',
          tooltip: true,
        },
      ],
      dataSource2: [
        {
          name: '122',
          id: 100,
        },
      ],
      dataSource: [
        {
          name: '122',
          id: 100,
          children: [
            {
              id: 10000,
              name: '2223',
              children: [
                {
                  name: '2223',
                },
              ],
            },
          ],
        },
      ],
      size: 13,
      size2: 8,
    }
  },
  watch: {
    processLog() {
      console.log(this.processLog)
      this.getData()
    },
    modalLog() {
      if (this.type == 0) {
        this.getData2()
      }
    },
    tcpLog() {
      if (this.type == 1) {
        this.getData2()
      }
    },
  },
  mounted() {
    // this.$refs.scrollbar.addEventListener(
    //   'scroll',
    //   (e) => {
    //     console.log('父滚动条到页面顶部距离', e.target.offsetTop)
    //     console.log('相对距离', this.$refs.scrollbar.scrollTop)
    //     this.scrollbarTop = this.$refs.scrollbar.scrollTop
    //     this.getData()
    //   },
    //   false
    // )
    this.$refs.scrollbar2.addEventListener(
      'scroll',
      (e) => {
        console.log('父滚动条到页面顶部距离', e.target.offsetTop)
        console.log('相对距离', this.$refs.scrollbar2.scrollTop)
        this.scrollbarTop2 = this.$refs.scrollbar2.scrollTop
        this.getData2()
      },
      false
    )
    this.getData()
    this.getData2()
  },
  methods: {
    expandFn(key, status) {
      console.log(key)
      console.log(status)
    },
    searchFn() {
      // for (var i = 0; i++; i < this.processLog.length) {
      //   console.log(i)
      //   let index = this.processLog[i].path.indexOf(this.form.val)
      //   console.log(index)
      //   if (index != -1) {
      //     let overflowY = this.$el.getElementsByClassName('ivu-table-body')[0]
      //     if (!overflowY) {
      //       return
      //     }
      //     console.log(i)
      //     overflowY.scrollTop = 32 * Number(i)
      //     return false
      //   }
      // }
      let index = this.processLog.findIndex((val, j) => {
        let key = val.path.indexOf(this.form.val)
        if (key != -1) {
          return j
        }
      })
      console.log(index)
      if (index != -1) {
        let overflowY = this.$el.getElementsByClassName('ivu-table-body')[0]
        if (!overflowY) {
          return
        }
        overflowY.scrollTop = 32 * Number(index)
        return false
      }
      // this.$refs.processCom.scrollTo(0, 20)
    },
    changeType() {
      this.type = !this.type
      this.getData2()
    },
    getData2() {
      this.newModalLog = []
      this.newTcpLog = []
      if (!this.type) {
        this.scrollHeight2 = this.modalLog.length * 32 + 'px'
        let newData = [...this.modalLog]
        let index = Number(this.scrollbarTop2) / 32
        if (newData.length <= this.size2) {
          this.newModalLog = newData.slice(0, this.size2)
        } else {
          let len
          if (Number(parseInt(index)) + this.size2 > newData.length) {
            len = newData.length
          } else {
            len = Number(parseInt(index)) + this.size2
          }
          this.newModalLog = newData.slice(Number(parseInt(index)), len)
        }
      } else {
        this.scrollHeight2 = this.tcpLog.length * 32 + 'px'
        let newData = [...this.tcpLog]
        let index = Number(this.scrollbarTop2) / 32
        if (newData.length <= this.size2) {
          this.newTcpLog = newData.slice(0, this.size2)
        } else {
          let len
          if (Number(parseInt(index)) + this.size2 > newData.length) {
            len = newData.length
          } else {
            len = Number(parseInt(index)) + this.size2
          }
          this.newTcpLog = newData.slice(Number(parseInt(index)), len)
        }
      }
    },
    getData() {
      this.newProcessLog = []
      this.scrollHeight = this.processLog.length * 32 + 'px'
      let newData = [...this.processLog]
      let index = Number(this.scrollbarTop) / 32
      if (newData.length <= this.size) {
        this.newProcessLog = newData.slice(0, this.size)
      } else {
        let len
        if (Number(parseInt(index)) + this.size > newData.length) {
          len = newData.length
        } else {
          len = Number(parseInt(index)) + this.size
        }
        this.newProcessLog = newData.slice(Number(parseInt(index)), len)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.scrollbar {
  height: 460px;
  position: absolute;
  overflow: auto;
  top: 0;
  width: 30px;
  right: 0px;
}
.scrollbar2 {
  height: 300px;
  position: absolute;
  overflow: auto;
  top: 0;
  width: 30px;
  right: 0px;
}
</style>
